module.exports = __webpack_public_path__ + "img/apidays-banner.407572a3.jpg";